<template>
  <b-row>
    <b-col sm="12" md="10" lg="8">
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-col>
    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="lg"
      title="Proxímo status"
      @show="showModal"
      @hide="hideModal"
    >
      <div v-if="permissions == 2">
        <b-row>
          <b-col sm="12" md="6" lg="6">
            <cargo-crud-kanban
              ref="cargoCrudData"
              :model="model"
              :modelstate="modelstate"
              :readonly="canEdit"
            >
            </cargo-crud-kanban>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <custom-value-occurrence
              :occurrenceId="model.statusNew"
              :items.sync="model.values"
              :readonly="canEdit"
            >
            </custom-value-occurrence>
          </b-col>
        </b-row>
      </div>
      <div v-else-if="permissions == 1">
        <b-row>
          <b-col sm="12" md="6" lg="12">
            <cargo-crud-kanban
              ref="cargoCrudData"
              :model="model"
              :modelstate="modelstate"
              :readonly="!canEdit"
            >
            </cargo-crud-kanban>
          </b-col>
        </b-row>
        <!-- {{model}} -->
        <b-row>
          <b-col>
            <custom-value-occurrence
              :occurrenceId="model.statusNew"
              :items.sync="model.values"
              :readonly="!canEdit"
              :modelstate="modelstate"
            >
            </custom-value-occurrence>
          </b-col>
        </b-row>
        <b-row>
          <!-- <b-col>
            <b-button class="button" @click="save" :disabled="canSubmit">
              {{ $t("geral.save") }}
            </b-button>
          </b-col> -->
        </b-row>
      </div>

      <div v-if="permissions == 0">
        <h4>Você não possui acesso a edição desta esta carga</h4>
      </div>

      <template #modal-footer="{ cancel }">
        <div class="right">
          <b-button variant="green" @click="save($event)" :disabled="canSubmit">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-row>
</template>
<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
export default {
  name: "KanbanEditModal",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    CustomValueOccurrence: () =>
      import(
        "@/components_rms/trackingShippingCompany/occurrenceType/CustomValueOccurrence.vue"
      ),
    CargoCrudKanban: () =>
      import("@/components_rms/tracking/cargo/CargoCrudKanban.vue"),
  },
  props: {
    id: Number,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {
        cargoActive: true,
        clientName: "",
        companyId: "",
        companyBranchName: "",
        dateAttendance: "",
        dateDeliveryForecast: "",
        destinationCityName: "",
        originCityName: "",
        status: 1,
        statusNew: 1,
        vehicleTypeName: "",
        weight: "0.00",
        values: [],
        cargoPath: [],
      },
      permissions: 0,
    };
  },
  computed: {
    canEdit() {
      if (!this.model) {
        return false;
      }
      if (!this.model.cargoActive) {
        return true;
      }
      // if (this.model.status == 13) {
      //   return false;
      // }
      return true;
    },
    canSubmit() {
      if (this.submitted) {
        return true;
      }
      if (!this.canEdit) {
        return true;
      }
      return false;
    },
    getUrlCargoList() {
      if (this.companyId) {
        return `cargo/get/${this.id}/${this.companyId}`;
      }
      return `cargo/get/${this.id}`;
    },
    getUrlPermission() {
      return `v1/getOccurrencePermissions/${this.id}`;
    },
  },
  methods: {
    show() {
      this.$refs.openModal.show();
    },
    async loadData() {
      this.$api
        .get(this.getUrlCargoList)
        .then((response) => {
          let model = response.data;
          model.statusNew = 1;
          if (model.status == 13) model.status = 1;
          if (model.statusNew == 13) model.statusNew = 1;
          this.model = model;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    save(e) {
      this.submitted = true;
      this.$refs.cargoCrudData.dataFormat();

      this.$api
        .post(
          "/v1/cargo/occurrence/" + this.model.cargoId.toString(),
          this.model
        )
        .then((response) => {
          e.preventDefault();
          this.model = response.data;
          this.$refs.alert.show();
          this.modelstate = {};
          this.submitted = false;
          this.$emit("refresh");
          this.$emit("confirmEdit");
          this.$refs.openModal.hide();
        })
        .catch((error) => {
          console.log("error");
          console.log(error);
          // this.$refs.openModal.hide();
          this.submitted = false;
          this.modelstate = {};
          if (error.response) {
            console.log(error.response);
            console.log(error.response.data.errors);
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = error.message;
              this.$refs.danger.show();
            } else if (error.response.status == 500) {
              console.log(error.response);
              this.alert.error = error.response.data.detail;
              this.$refs.danger.show();
            } else if (error.response.status == 404) {
              this.alert.error = error.response.data.message;
              this.$refs.danger.show();
              console.log("ok");
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    getPermision() {
      this.$api
        .get(this.getUrlPermission)
        .then((response) => {
          this.permissions = response.data.permissions;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    hideModal() {
      this.loadData();
    },
    showModal() {
      this.getPermision();
      this.loadData();
    },
  },
};
</script>
